import { useMsal } from "@azure/msal-react";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import { useEffect, useState } from "react";

const MobileHeader = () => {
  const { instance } = useMsal();
  const [name, setName] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const account = instance.getAllAccounts()[0];
    if (account) {
      setName(account.name);
    }
  }, [instance]);

  function handleLogout() {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  }

  function handleBurger() {
    if (open) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }

  return (
    <header className="mobile-header">
      <div className="mobile-heading">
        <h1 className="portal-heading">Karrierekonto</h1>
        <div className="burger">
          <div
            className={`burger-menu ${open ? "open" : ""}`}
            onClick={handleBurger}
          >
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
      <nav className={`mobile-nav ${open ? "open" : ""}`}>
        <div className="account-details">
          <PersonOutlineIcon style={{ marginRight: "16px" }} fontSize="large" />
          <div className="account-text">{name}</div>
        </div>
        <button className="button-sidebar" onClick={handleLogout}>
          <LogoutIcon />
          <span>Logout</span>
        </button>
      </nav>
    </header>
  );
};

export default MobileHeader;
